import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'yoyakuStatusMarkId'
})
export class YoyakuStatusMarkIdPipe implements PipeTransform {

  transform(list: any,per :any): any {
    //無効の場合「－」
    if (list.invalid_flg == 1) {
      return 0;
    }
    //条件不一致の場合「×」
    if (list.mismatch == 1) {
      return 1;
    }
    //予約表に混雑割合が設定されている（0より大きい）場合
    if (per > 0) {
      if (list.zan_count_per >= 1 || list.zan_point_per >= 1) {
        //人数が100%超えるまたはポイントが100%超える場合「×」
        return 1;
      } else if (list.max_count == 0 || list.max_point == 0) {
        //上限人数または上限ポイントが「0」で設定されている場合「×」
        return 1;
      } else if (list.zan_count_per >= per || list.zan_point_per >= per) {
        //残人数または残ポイントが予約表の混雑割合を超えている場合「△」
        return 2;
      } else {
        //「○」
        return 3;
      }
    } else {
      if (list.zan_count_per >= 1 || list.zan_point_per >= 1) {
        //人数が100%超えるまたはポイントが100%超える場合「×」
        return 1;
      } else if (list.max_count == 0 || list.max_point == 0) {
        //上限人数または上限ポイントが「0」で設定されている場合「×」
        return 1;
      } else {
        //「○」
        return 3;
      }
    }
  }
  
}


// WEBPACK FOOTER //
// ./src/app/pipes/yoyaku-status-mark-id.pipe.ts